import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { Loading } from 'router/Loading'
import { useAppSelector, useActions } from 'store/hooks'

import {
  OrderStepContent,
  OrderStepLayout,
} from '../CreateOrder/OrderStepLayout'
import { ProductOrderFooter } from '../CreateOrder/ProductOrderFooter'
import { ProductOrderHeader } from '../CreateOrder/ProductOrderHeader'
import { orderFormSpace } from '../namespaces/orderFormSpace'
import { useGetProdParamsByTypeIdsQuery } from '../redux/orders.api'
import { StepComponentProps } from '../types/StepComponentProps'

import style from './OrderStepSelectProdParams.module.scss'
import { ProductSelectParamsCard } from './ProductSelectParamsCard/ProductSelectParamsCard'

// шаг 2
// выбор параметров для продукта
export function OrderStepSelectProdParams({
  completeStep,
  handlePrevious,
}: StepComponentProps) {
  const handleCompleteStep = () => completeStep(false)
  const handlePreviousStep = () => {
    handlePrevious(false)
    window.scrollTo(0, 0)
  }
  const { initParamsOrder } = useActions()
  const [isValid, setIsValid] = useState(true)

  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const productsSelected: orderFormSpace.Product[] = useAppSelector(
    state => state.orderForm.forms[currentEditForm].products,
  )
  const images: orderFormSpace.Images[] = useAppSelector(
    state => state.orderForm.forms[currentEditForm].images,
  )

  const { data: ProductParamData, isLoading } =
    useGetProdParamsByTypeIdsQuery(productsSelected)
  useEffect(() => {
    if (ProductParamData) initParamsOrder(ProductParamData)
  }, [ProductParamData])

  //откат назад если удалили все продукты
  useEffect(() => {
    if (productsSelected.length < 1) {
      handlePrevious(false)
    }
  }, [handlePrevious, productsSelected])

  // блокируем кнопку далее когда изображения грузиться
  useEffect(() => {
    const validCount = images.reduce(
      (all, cur) => (cur.serverUid ? all + 1 : all - 1),
      0,
    )
    if (validCount === images.length) {
      setIsValid(true)
    } else setIsValid(false)
  }, [images])

  if (isLoading) return <Loading />

  return (
    <OrderStepLayout>
      <ProductOrderHeader
        step='Шаг 2'
        title='Уточнение параметров'
        description='Введите примерные параметры изделия,
        чтобы мы подобрали подходящий для вас вариант'
      />
      <OrderStepContent>
        <div className={style.orderPropsWrapper}>
          <div className={style.orderProps}>
            {ProductParamData?.list.map(item => (
              <ProductSelectParamsCard data={item} key={item.productId} />
            ))}
          </div>
        </div>
      </OrderStepContent>
      <ProductOrderFooter
        nextButton={{
          onClick: handleCompleteStep,
          Icon: <ChevronRightRounded />,
          text: 'Далее',
          disabled: !isValid,
        }}
        prevButton={{
          onClick: handlePreviousStep,
          Icon: <ChevronLeftRounded />,
          text: 'Предыдущий шаг',
        }}
      />
    </OrderStepLayout>
  )
}
